
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33893',
  depVersions: {
  "documents-public-ui": "static-1.33893",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33898",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1892",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5359",
  "hs-test-utils": "static-1.7773",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11187",
  "I18n": "static-7.1561",
  "jasmine-immutable": "static-1.2786",
  "jasmine-runner": "static-1.6241",
  "lodash": "static-1.3",
  "quartz": "static-1.6684",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16408",
  "reporting-data": "static-1.66384",
  "reporting-testing-lib": "static-1.8317",
  "reporting-visualizations": "static-1.58460",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4533",
  "webpack-env": "static-1.54",
  "atom": "static-1.4838",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2253",
  "classnames": "static-2.10",
  "cssUtils": "static-1.723",
  "customer-data-filters-ui": "static-1.38770",
  "customer-data-objects": "static-1.7412",
  "customer-data-property-utils": "static-1.7839",
  "data-fetching-client": "static-1.9445",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4298",
  "flux-actions": "static-1.304",
  "FormsCommonComponents": "static-1.85203",
  "FormUrlGenerator": "static-2.4498",
  "foundations-components": "static-1.7462",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11495",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6930",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3627",
  "property-translator": "static-1.5181",
  "quartz-config": "static-1.462",
  "quartz-core": "static-1.5903",
  "quick-fetch": "static-1.3703",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5144",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7928",
  "reference-resolvers-lite": "static-1.7858",
  "report-customization-components": "static-1.12413",
  "reporting-enablement": "static-1.21964",
  "reporting-reports": "static-1.66062",
  "reporting-snowflake": "static-1.55002",
  "reporting-ui-components": "static-2.63655",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4400",
  "sales-content-partitioning": "static-1.8703",
  "SalesContentIndexUI": "static-3.8853",
  "sanitize": "static-1.4242",
  "sanitize-text": "static-1.7908",
  "self-service-api": "static-1.10004",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1522",
  "signup-constants": "static-1.18327",
  "signup-ui-lego-core": "static-1.20337",
  "signup-ui-url-generator": "static-2.7832",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4539",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10762",
  "ui-addon-i18n": "static-1.10900",
  "ui-addon-react-router-dom": "static-1.9316",
  "ui-addon-upgrades": "static-9.17602",
  "ui-asset-management-lib": "static-1.10666",
  "ui-images": "static-2.1083",
  "UIComponents": "static-3.8134",
  "usage-tracker": "static-1.7101",
  "usage-tracker-container": "static-1.7091",
  "usage-tracker-core": "static-1.6951",
  "usage-tracker-public": "static-1.6912",
  "viral-links-lib": "static-1.6797",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3195",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2961",
  "quartz-webpack": "static-1.2908",
  "ai-components-ui-library": "static-1.8265",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4601",
  "foundations-theming": "static-1.4176",
  "quartz-auth": "static-1.359",
  "usage-tracker-session-replay": "static-1.4787",
  "foundations-theming-base": "static-1.3161",
  "HeadJS": "static-2.703",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2884",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4098",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7692",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3475",
  "reporting-client-types": "static-1.2377",
  "hs-story-utils": "static-1.9196",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9402",
  "hubspotter-http": "static-1.4448",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7017",
  "crm-message-bus": "static-1.42256",
  "customer-data-filters-ui-msw-helpers": "static-1.21204",
  "customer-data-objects-ui-components": "static-1.12772",
  "customer-data-reference-ui-components": "static-1.12911",
  "customer-data-ui-utilities": "static-1.9592",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6543",
  "framework-data-schema-resolvers": "static-1.6638",
  "inbound-db-properties-service-client": "static-1.3646",
  "multi-account-reference-resolvers": "static-1.737",
  "onboarding-tours": "static-1.16214",
  "reporting-datasets-permissions-lib": "static-1.12964",
  "ui-addon-teams": "static-1.21196",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67529",
  "customer-data-properties": "static-1.50696",
  "forms-ai-lib": "static-1.3966",
  "forms-utils-lib": "static-1.12111",
  "foundations-components-test-utils": "static-1.4945",
  "react-dnd-compat": "static-1.4391",
  "react-tinymce": "static-1.54536",
  "tinymce-config": "static-2.53662",
  "ui-gdpr-components": "static-1.10115",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3731",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1104",
  "ui-fonts": "static-1.449",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.786",
  "mobile-manifest-mixins": "static-1.476",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.349",
  "quartz-i18n": "static-1.359",
  "quartz-routing": "static-1.114",
  "quartz-test": "static-1.359",
  "batch-promise": "static-1.1318",
  "external-options-client-types": "static-1.3954",
  "react-colorpicker": "static-2.9980",
  "copilot-toolkit": "static-1.10444",
  "data-quality-ui-library": "static-1.12247",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40570",
  "reporting-insights-lib": "static-1.1069",
  "reporting-plugins": "static-1.9941",
  "ui-addon-draggable-compat": "static-2.4021",
  "ui-addon-opt": "static-4.8153",
  "ui-shepherd-react": "static-3.9913",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24635",
  "hubspot-apollo-client": "static-1.4647",
  "sales-templates-service-types-lib": "static-1.3964",
  "ui-business-units-lib": "static-1.8791",
  "merchandise-lib": "static-1.257",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5439",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3874",
  "upgrade-management-service-types": "static-1.4276",
  "timezone-utils": "static-2.5012",
  "bender-build-tools": "static-1.2903",
  "chatspot-core": "static-1.20187",
  "chirp-fetch": "static-1.1651",
  "bend-plugin-foundations-theming": "static-1.2659",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9400",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3594",
  "crm-pipelines-api-client-types": "static-1.3935",
  "multi-currency-client-types": "static-1.3488",
  "getting-started-shared-tasks": "static-1.17791",
  "growth-data-modal": "static-1.5119",
  "growth-onboarding-confetti": "static-1.2838",
  "growth-onboarding-next-action-utils": "static-1.1263",
  "navigation-components": "static-1.17166",
  "onboarding-tours-client": "static-1.4428",
  "onboarding-tours-utils": "static-1.280",
  "ui-shepherd-tracker": "static-1.7294",
  "ui-universal-auth": "static-1.8648",
  "user-context": "static-1.4862",
  "cms-field-types": "static-1.4574",
  "content-icons-ui": "static-1.2144",
  "integrations-lib": "static-1.15314",
  "calling-global-api": "static-1.63546",
  "calling-internal-common": "static-1.31060",
  "calling-lifecycle-internal": "static-1.64928",
  "calling-lifecycle-messages": "static-1.57222",
  "commerce-products-lib": "static-1.8761",
  "crm-links": "static-1.6023",
  "file-manager-components": "static-1.22795",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.441",
  "inbounddb-objects-service-types": "static-1.4020",
  "meetings-icalendar-utils-lib": "static-1.402",
  "object-builder-ui-client": "static-1.47866",
  "pipeline-validation-client-types": "static-1.3757",
  "property-value-citations": "static-1.1310",
  "pulse": "static-1.272",
  "smart-property-lib": "static-1.5762",
  "tiered-pricing": "static-1.781",
  "ui-addon-iframeable": "static-1.8809",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19420",
  "tinymce-themes": "static-1.55632",
  "data-token-picker": "static-1.15992",
  "hub-http-contrib": "static-1.2812",
  "interframe": "static-3.4559",
  "tinymce-data": "static-1.39747",
  "tinymce-plugins": "static-1.56776",
  "ui-addon-sales-email": "static-1.4981",
  "magpie-lib": "static-1.5362",
  "magpie-types": "static-1.4822",
  "simple-logging-lib": "static-1.2818",
  "content-assistance-lib": "static-1.7402",
  "dashboard-lib": "static-1.80484",
  "ExportDialog": "static-6.10156",
  "hubspot-prosemirror": "static-1.17514",
  "hubspot-prosemirror-plugins": "static-1.17506",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8459",
  "campaign-roi-lib": "static-1.8182",
  "feedback-loader": "static-1.28793",
  "onboarding-scopes": "static-1.6232",
  "apollo-link-hub-http": "static-2.4417",
  "hubspot-apollo-cache": "static-1.106",
  "growth-monetization-service-types": "static-1.4292",
  "nav-client-types": "static-1.2124",
  "purchase-motions-api": "static-1.5442",
  "trials-service-types": "static-1.3693",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.494",
  "unified-auth-core-lib": "static-1.443",
  "getting-started-shared-tasks-store": "static-1.16909",
  "integrations-error-boundary-lib": "static-1.12729",
  "integrations-tracking-lib": "static-1.5352",
  "native-integrations-shared-strings": "static-1.7556",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10140",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31066",
  "shared-worker-versioning": "static-1.10805",
  "calling-usage-tracker": "static-1.6306",
  "voice-sms-access-library": "static-1.151",
  "customer-data-tracking": "static-1.6650",
  "products-iframe-lib": "static-1.7230",
  "products-ui-components-shared-msw-handlers": "static-1.9784",
  "location-customization-utils-lib": "static-1.8457",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3922",
  "video-components-external": "static-1.10481",
  "video-data-lib": "static-1.34139",
  "directed-graph": "static-1.705",
  "event-emitter": "static-1.715",
  "breeze-intelligence-kit": "static-1.5275",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9485",
  "fsm": "static-1.3499",
  "policy-lib": "static-1.6553",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9548",
  "navigation-messaging": "static-1.6493",
  "FileManagerLib": "static-1.38435",
  "NamespacedHubStyle": "static-2.8867",
  "FileManagerCore": "static-1.38294",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.11976",
  "layout-dnd-utils": "static-1.10951",
  "react-codemirror": "static-1.10394",
  "ui-addon-emoji-picker": "static-1.9657",
  "ui-brand-identity-lib": "static-1.13718",
  "ui-addon-video-player": "static-1.8464",
  "ui-coaching-tips": "static-1.27861",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8337",
  "payment-link-components": "static-1.22851",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2974",
  "universal-page-editor-lib": "static-1.2764",
  "calling-orchestration-schema": "static-1.34928",
  "sales-views-client-types": "static-1.4060",
  "crm-record-cards-service-types": "static-1.3422",
  "content-media-composition-data-lib": "static-1.11337",
  "content-media-compositions": "static-2.15344",
  "media-bridge-lib": "static-1.18514",
  "trellis-story-utils": "static-1.4291",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5567",
  "FileManagerImages": "static-1.35946",
  "video-components": "static-1.12484",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4302",
  "video-embed": "static-1.34973",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67604",
  "layout-data-lib": "static-1.9276",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6353",
  "commerce-tours-lib": "static-1.5669",
  "growth-onboarding-reliability": "static-1.4856",
  "sales-checkout-service-client": "static-1.3446",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21258",
  "sales-email-signature-service-client": "static-1.3613",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21265",
  "outpost": "static-1.3975",
  "advanced-menus-core": "static-1.14770",
  "advanced-menus-lib": "static-1.11752",
  "ui-memberships-settings-lib": "static-1.33345",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14769",
  "simple-menus-lib": "static-1.16286"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33893",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33898",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1892",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5359",
  "hs-test-utils": "/hs-test-utils/static-1.7773",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11187",
  "I18n": "/I18n/static-7.1561",
  "jasmine-immutable": "/jasmine-immutable/static-1.2786",
  "jasmine-runner": "/jasmine-runner/static-1.6241",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6684",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16408",
  "reporting-data": "/reporting-data/static-1.66384",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8317",
  "reporting-visualizations": "/reporting-visualizations/static-1.58460",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4533",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4838",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2253",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.723",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38770",
  "customer-data-objects": "/customer-data-objects/static-1.7412",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7839",
  "data-fetching-client": "/data-fetching-client/static-1.9445",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4298",
  "flux-actions": "/flux-actions/static-1.304",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85203",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4498",
  "foundations-components": "/foundations-components/static-1.7462",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11495",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6930",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3627",
  "property-translator": "/property-translator/static-1.5181",
  "quartz-config": "/quartz-config/static-1.462",
  "quartz-core": "/quartz-core/static-1.5903",
  "quick-fetch": "/quick-fetch/static-1.3703",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5144",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7928",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7858",
  "report-customization-components": "/report-customization-components/static-1.12413",
  "reporting-enablement": "/reporting-enablement/static-1.21964",
  "reporting-reports": "/reporting-reports/static-1.66062",
  "reporting-snowflake": "/reporting-snowflake/static-1.55002",
  "reporting-ui-components": "/reporting-ui-components/static-2.63655",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4400",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8703",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8853",
  "sanitize": "/sanitize/static-1.4242",
  "sanitize-text": "/sanitize-text/static-1.7908",
  "self-service-api": "/self-service-api/static-1.10004",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1522",
  "signup-constants": "/signup-constants/static-1.18327",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20337",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7832",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4539",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10762",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10900",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9316",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17602",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10666",
  "ui-images": "/ui-images/static-2.1083",
  "UIComponents": "/UIComponents/static-3.8134",
  "usage-tracker": "/usage-tracker/static-1.7101",
  "usage-tracker-container": "/usage-tracker-container/static-1.7091",
  "usage-tracker-core": "/usage-tracker-core/static-1.6951",
  "usage-tracker-public": "/usage-tracker-public/static-1.6912",
  "viral-links-lib": "/viral-links-lib/static-1.6797",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2961",
  "quartz-webpack": "/quartz-webpack/static-1.2908",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8265",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4601",
  "foundations-theming": "/foundations-theming/static-1.4176",
  "quartz-auth": "/quartz-auth/static-1.359",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4787",
  "foundations-theming-base": "/foundations-theming-base/static-1.3161",
  "HeadJS": "/HeadJS/static-2.703",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2884",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4098",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7692",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3475",
  "reporting-client-types": "/reporting-client-types/static-1.2377",
  "hs-story-utils": "/hs-story-utils/static-1.9196",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9402",
  "hubspotter-http": "/hubspotter-http/static-1.4448",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7017",
  "crm-message-bus": "/crm-message-bus/static-1.42256",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21204",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12772",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12911",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9592",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6543",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6638",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3646",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.737",
  "onboarding-tours": "/onboarding-tours/static-1.16214",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12964",
  "ui-addon-teams": "/ui-addon-teams/static-1.21196",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67529",
  "customer-data-properties": "/customer-data-properties/static-1.50696",
  "forms-ai-lib": "/forms-ai-lib/static-1.3966",
  "forms-utils-lib": "/forms-utils-lib/static-1.12111",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4945",
  "react-dnd-compat": "/react-dnd-compat/static-1.4391",
  "react-tinymce": "/react-tinymce/static-1.54536",
  "tinymce-config": "/tinymce-config/static-2.53662",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10115",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3731",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1104",
  "ui-fonts": "/ui-fonts/static-1.449",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.786",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.476",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.349",
  "quartz-i18n": "/quartz-i18n/static-1.359",
  "quartz-routing": "/quartz-routing/static-1.114",
  "quartz-test": "/quartz-test/static-1.359",
  "batch-promise": "/batch-promise/static-1.1318",
  "external-options-client-types": "/external-options-client-types/static-1.3954",
  "react-colorpicker": "/react-colorpicker/static-2.9980",
  "copilot-toolkit": "/copilot-toolkit/static-1.10444",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12247",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40570",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1069",
  "reporting-plugins": "/reporting-plugins/static-1.9941",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4021",
  "ui-addon-opt": "/ui-addon-opt/static-4.8153",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9913",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24635",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4647",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3964",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8791",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5439",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3874",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4276",
  "timezone-utils": "/timezone-utils/static-2.5012",
  "bender-build-tools": "/bender-build-tools/static-1.2903",
  "chatspot-core": "/chatspot-core/static-1.20187",
  "chirp-fetch": "/chirp-fetch/static-1.1651",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2659",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9400",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3594",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3935",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3488",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17791",
  "growth-data-modal": "/growth-data-modal/static-1.5119",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2838",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1263",
  "navigation-components": "/navigation-components/static-1.17166",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4428",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.280",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7294",
  "ui-universal-auth": "/ui-universal-auth/static-1.8648",
  "user-context": "/user-context/static-1.4862",
  "cms-field-types": "/cms-field-types/static-1.4574",
  "content-icons-ui": "/content-icons-ui/static-1.2144",
  "integrations-lib": "/integrations-lib/static-1.15314",
  "calling-global-api": "/calling-global-api/static-1.63546",
  "calling-internal-common": "/calling-internal-common/static-1.31060",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64928",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57222",
  "commerce-products-lib": "/commerce-products-lib/static-1.8761",
  "crm-links": "/crm-links/static-1.6023",
  "file-manager-components": "/file-manager-components/static-1.22795",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.441",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4020",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.402",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47866",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3757",
  "property-value-citations": "/property-value-citations/static-1.1310",
  "pulse": "/pulse/static-1.272",
  "smart-property-lib": "/smart-property-lib/static-1.5762",
  "tiered-pricing": "/tiered-pricing/static-1.781",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8809",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19420",
  "tinymce-themes": "/tinymce-themes/static-1.55632",
  "data-token-picker": "/data-token-picker/static-1.15992",
  "hub-http-contrib": "/hub-http-contrib/static-1.2812",
  "interframe": "/interframe/static-3.4559",
  "tinymce-data": "/tinymce-data/static-1.39747",
  "tinymce-plugins": "/tinymce-plugins/static-1.56776",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4981",
  "magpie-lib": "/magpie-lib/static-1.5362",
  "magpie-types": "/magpie-types/static-1.4822",
  "simple-logging-lib": "/simple-logging-lib/static-1.2818",
  "content-assistance-lib": "/content-assistance-lib/static-1.7402",
  "dashboard-lib": "/dashboard-lib/static-1.80484",
  "ExportDialog": "/ExportDialog/static-6.10156",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17514",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17506",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8459",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "feedback-loader": "/feedback-loader/static-1.28793",
  "onboarding-scopes": "/onboarding-scopes/static-1.6232",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4417",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.106",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4292",
  "nav-client-types": "/nav-client-types/static-1.2124",
  "purchase-motions-api": "/purchase-motions-api/static-1.5442",
  "trials-service-types": "/trials-service-types/static-1.3693",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.494",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.443",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16909",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12729",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5352",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7556",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10140",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31066",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10805",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6306",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.151",
  "customer-data-tracking": "/customer-data-tracking/static-1.6650",
  "products-iframe-lib": "/products-iframe-lib/static-1.7230",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9784",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8457",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3922",
  "video-components-external": "/video-components-external/static-1.10481",
  "video-data-lib": "/video-data-lib/static-1.34139",
  "directed-graph": "/directed-graph/static-1.705",
  "event-emitter": "/event-emitter/static-1.715",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5275",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9485",
  "fsm": "/fsm/static-1.3499",
  "policy-lib": "/policy-lib/static-1.6553",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9548",
  "navigation-messaging": "/navigation-messaging/static-1.6493",
  "FileManagerLib": "/FileManagerLib/static-1.38435",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8867",
  "FileManagerCore": "/FileManagerCore/static-1.38294",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.11976",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10951",
  "react-codemirror": "/react-codemirror/static-1.10394",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9657",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13718",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8464",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27861",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8337",
  "payment-link-components": "/payment-link-components/static-1.22851",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2974",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2764",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34928",
  "sales-views-client-types": "/sales-views-client-types/static-1.4060",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3422",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11337",
  "content-media-compositions": "/content-media-compositions/static-2.15344",
  "media-bridge-lib": "/media-bridge-lib/static-1.18514",
  "trellis-story-utils": "/trellis-story-utils/static-1.4291",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5567",
  "FileManagerImages": "/FileManagerImages/static-1.35946",
  "video-components": "/video-components/static-1.12484",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4302",
  "video-embed": "/video-embed/static-1.34973",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67604",
  "layout-data-lib": "/layout-data-lib/static-1.9276",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6353",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5669",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4856",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3446",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21258",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3613",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "outpost": "/outpost/static-1.3975",
  "advanced-menus-core": "/advanced-menus-core/static-1.14770",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11752",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33345",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14769",
  "simple-menus-lib": "/simple-menus-lib/static-1.16286"
}
};
